import React, { useState, useCallback, useEffect } from "react";
import Sidebar from "./Sidebar";
import Header from "./Header";
import PendingRequestsWatcher from "../PendingRequestsWatcher";

const SIDEBAR_COLLAPSED_KEY = "admin-sidebar-collapsed";

function getInitialSidebarCollapsed(): boolean {
    try {
        return localStorage.getItem(SIDEBAR_COLLAPSED_KEY) === "true";
    } catch {
        return false;
    }
}

interface DashboardLayoutProps {
    children: React.ReactNode;
}

const DashboardLayout: React.FC<DashboardLayoutProps> = ({ children }) => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [isDesktopSidebarCollapsed, setIsDesktopSidebarCollapsed] = useState(
        getInitialSidebarCollapsed
    );

    useEffect(() => {
        try {
            localStorage.setItem(
                SIDEBAR_COLLAPSED_KEY,
                isDesktopSidebarCollapsed ? "true" : "false"
            );
        } catch {
            // ignore
        }
    }, [isDesktopSidebarCollapsed]);

    const toggleMobileMenu = useCallback(() => {
        setIsMobileMenuOpen((prev) => !prev);
    }, []);

    const toggleDesktopSidebar = useCallback(() => {
        setIsDesktopSidebarCollapsed((prev) => !prev);
    }, []);

    return (
        <div className="flex h-screen overflow-hidden bg-gray-100 dark:bg-gray-900">
            <PendingRequestsWatcher />
            <Sidebar
                isMobileMenuOpen={isMobileMenuOpen}
                onMobileMenuToggle={toggleMobileMenu}
                isDesktopSidebarCollapsed={isDesktopSidebarCollapsed}
                onDesktopSidebarToggle={toggleDesktopSidebar}
            />
            <div className="flex-1 flex flex-col overflow-hidden lg:ml-0">
                <Header
                    onMenuToggle={toggleMobileMenu}
                    isDesktopSidebarCollapsed={isDesktopSidebarCollapsed}
                    onDesktopSidebarToggle={toggleDesktopSidebar}
                />
                <main className="flex-1 overflow-x-hidden overflow-y-auto bg-gray-100 dark:bg-gray-900 p-4 lg:p-6">
                    {children}
                </main>
            </div>
        </div>
    );
};

export default DashboardLayout;
